
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
data(){
return{
IsArry:[
{
key:'1',
value:'是'
},
{
key:'2',
value:'否'
}
],
value:[],
cloums:{}
}
},
props: {
data: {
type: Object,
default: {

},
immediate:true
},
index:{
type: Number,
default: {

},
}
},
watch:{
data:{
handler(newval,oldvalue) {
this.cloums = newval;
},
immediate:true
}
},
components: {
Checker, CheckerItem
},
methods:{
change(value){
this.cloums.answer = value;
this.$emit('change',{value:value,cloums:this.cloums,index:this.index});
/*  console.log(value,2222,this.cloums.type)*/
}
},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/components/questionnaireTempelet/judementTempelet.vue